import { Locale } from "i18n/config";

export function convertToPriceStr(cents: number, locale: Locale) {
  return (cents / 100).toLocaleString(locale, {
    style: "currency",
    currency: "EUR",
  });
}

export function convertToMonthlyPriceStr(
  cents: number,
  locale: Locale,
  dayAbrv: string,
) {
  return `${convertToPriceStr(cents, locale)}/30 ${dayAbrv}`;
}
